var Handlebars = require("handlebars/dist/handlebars");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "\n<p>Specify which branch licenses will be renewed along with the principal license.</p>\n\n<div class=\"branch-licenses-container\"></div>";
},"useData":true});